import {
    BuildingSolid,
    CalendarMonthSolid,
    ChartPieSolid, CogSolid, FolderDuplicateSolid,
    GridPlusSolid,
    GridSolid, PhoneSolid, SalePercentSolid,
    UsersSolid
} from "flowbite-svelte-icons";

export default [
    {
        label: 'Dashboard',
        href: '/',
        icon: ChartPieSolid
    },

    {
        label: 'new Project',
        href: '/create/project',
        icon: GridPlusSolid
    },

    {
        label: 'Projects',
        href: '/projects',
        icon: GridSolid
    },
    {
        label: 'Calendar',
        href: '/calendar',
        icon: CalendarMonthSolid
    },

    {
        label: 'Employees',
        href: '/employees',
        alias: '/employee',
        icon: UsersSolid
    },
    {
        label: 'Clients',
        href: '/clients',
        icon: BuildingSolid
    },
    {
        label: 'Documents',
        href: '/documents',
        icon: FolderDuplicateSolid
    },
    {
        label: 'Telephone',
        href: '/telephone-interview',
        icon: PhoneSolid
    },
    {
        label: 'Settings',
        href: '/settings',
        icon: CogSolid
    },
    {
        label: 'Sales',
        href: '/sales',
        icon: SalePercentSolid
    }
]
